module.exports = __webpack_public_path__ + "static/media/32PerformancePhotos.b073d9c1.jpeg";